import { IGetState } from '../../../../../../../../types/types';
import { Dispatch, ThunkAction } from '../../../../../../../../types/actions';
import { changeHideDone } from '../effects/changeHideDone';

export const onHideDoneChange = (
): ThunkAction => {
    const action = (
        dispatch: Dispatch,
        getState: IGetState
    ) => {
        return dispatch(changeHideDone());
    };
    return action;
};
